import React, {Component} from 'react';
import { Select } from 'antd';

const { Option } = Select;


class FontSizeTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value:'字号',
            options: [
                {key: '字号', val:'字号'},
                {key:'10px', val:'六号(10px)'},
                {key:'12px', val:'小五(12px)'},
                {key:'14px', val:'五号(14px)'},
                {key:'16px', val:'小四(16px)'},
                {key:'18px', val:'四号(18px)'},
                {key:'20px', val:'小三(20px)'},
                {key:'21px', val:'三号(21px)'},
                {key:'24px', val:'小二(24px)'},
                {key:'29px', val:'二号(29px)'},
                {key:'32px', val:'小一(32px)'},
                {key:'34px', val:'一号(34px)'},
                {key:'48px', val:'小号(48px)'},
                {key:'56px', val:'初号(56px)'},
            ]
        }
    }
    render() {
        return (
            <span>
                <Select size={"small"} placeholder={'字号'} value={this.state.value} style={{width:this.props.width}} dropdownMatchSelectWidth={false} dropdownClassName={'fontSizeSelect'}
                        onChange={(e)=>{
                            this.setState({value:e});
                            this.props.editor.execCommand( 'fontsize', e)
                        }}
                >
                    {this.state.options.map(item=>{
                        if(item.key === "字号") {
                            return ""
                        }
                        return <Option key={item.key} value={item.key} style={{fontSize:item.key,lineHeight:item.key}}>{item.val}</Option>
                    })}
                </Select>
                <style>
                    {`.fontSizeSelect .ant-select-dropdown-menu-item {padding: 2px 12px}` }
                </style>
            </span>
        );
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue("FontSize");
        this.setState({value:ulKey});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue("FontSize");
        this.setState({value:ulKey});
    }
}

export default FontSizeTool;